<template>
  <div>
    <div role="alert" class="alert alert-info" style="max-width:640px; margin:0 auto">
        <button type="button" aria-label="Close" class="close" @click="closeLogoutNotification()"><span aria-hidden="true">×</span></button>
        <p style="margin-bottom:1em">
            <span>
              Logout complete
            </span>
        </p>
        <p style="border-top:1px solid #87B0C4; padding-top:1em; opacity:0.7; font-size:90%">
            <b-icon-lock-fill style="float:left; font-size:32px; width:46px; opacity:0.5; margin:2px 0 40px 0">&nbsp;</b-icon-lock-fill>
              Security Notice:
              XMission will <b>never</b> contact you to ask for your password, account or other personal information. If you receive any request of this nature, please contact us immediately at 801-539-0852 or <a href="mailto:support@xmission.com">support@xmission.com</a>.
        </p>
    </div>
    <br>
  </div>
</template>

<script>
  import * as types from '@/store/mutation-types'
  import { BIconLockFill } from 'bootstrap-vue';

  export default {
    name: 'LogoutNotification',
    methods: {
      closeLogoutNotification () {
        this.$store.commit(types.HIDE_LOGOUT_NOTIFICATION)
      }
    },
    components: {
      BIconLockFill
    }
  }
</script>

<style scoped>
@media (max-width: 768px) {
  .mobile-top-pad {padding-top:1em}
}

h4.underlined {
  border-bottom:1px solid #ccc;
  padding-bottom:0.5em
}


/**redundant**/
tr.vam td, table.vam td, div.vam {
  vertical-align:middle !important;
}

.red {color:red}
.bottom-margin {margin-bottom:1.75em}

.uppercase {
  text-transform:uppercase
}

.nolines td {
  border:0 !important;
}

.faded {opacity:0.5}
.row.faded label {font-weight:normal !important}
.largetext {font-size:120%}

.equal-height-children {display:flex; align-items: center; flex-wrap: wrap;
  }

.no-fx-form-control {border:0; box-shadow:none; padding-right:0; padding-left:0; background:transparent}
.text-align-right {text-align:right;}
.width-auto-inline {width:auto !important; display:inline-block;}

.h4-size-text {font-size:18px}
.borderless {border:0 !important}
</style>



// WEBPACK FOOTER //
// LogoutNotification.vue?555362e0